export default "__VITE_ASSET__BGMKCeU5__"